import React, { useContext } from "react"
import { UserContext } from './../../utils/usermanagement'
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { extractPageLocation } from "../../utils/utilityFunctions"

import { Link } from "gatsby"
import "./ArticleCard.scss";

const ArticleCard = ({article, engagement}) => {
	const [userState, userDispatch] = useContext(UserContext);
	
	const articleDoc = article.article.document;

	const articleData = articleDoc.data;
	const articleImage = getImage(articleData.hero_image.localFile.card);
	const articleURL = process.env.GATSBY_APP_DOMAIN + '/online-safety-tips/' +articleDoc.uid + '/';
	
	const dataLayerPushHandler = (event) => {
		let rollType="anonymous";
		let loginStatus="logged-out";
		let inPageLocation = extractPageLocation(event.target);
		
		if(userState && userState?.cognito_user?.username) {
			rollType="parent";
			loginStatus="logged-in";
		}

		const dataLayer = {
		  event: "help_article",
		  loginStatus: `${loginStatus}`,
		  actionType: "Link Click",
		  clickText: "Read more",
		  linkType: "internal",
		  linkUrl: `${articleURL}`,
		  moduleName: `${engagement} - Engagement`,
		  pageName: `${articleData.title}`,
		  inPageLocation: inPageLocation,
		  userType: `${rollType}`,
		};

		window.dataLayer.push(dataLayer);
	};

	return (
		<article className="article-card" onClick={(event) => dataLayerPushHandler(event)}>
			<Link to={`/online-safety-tips/${articleDoc.uid}/`} className="article-card--link">
					<div className="image-wrapper">
						<GatsbyImage image={articleImage} alt={articleData.hero_image.alt?articleData.hero_image.alt:articleData.title} />
					</div> 
					<div className="summary">
						<h3>{articleData.title}</h3>
						<div className="short-desc">{articleData.short_description}</div>
					</div>
					<div className="read-more text-end link link-primary arrow"> Read more</div>
			</Link>	
		</article>
	);
}

export default ArticleCard;
